import ConsultingHero from './components/ConsultingHero';
import ConsultingServices from './components/ConsultingServices';
import ConsultingWhoFor from './components/ConsultingWhoFor';
import ConsultingCTA from './components/ConsultingCTA';

const BusinessConsultingPage = () => {
  return (
    <main className="bg-[#030006] min-h-screen">
      <ConsultingHero />
      <ConsultingServices />
      <ConsultingWhoFor />
      <ConsultingCTA />
    </main>
  );
};

export default BusinessConsultingPage;
